export default {
  "path": "/demo/modal-confirm-modal",
  "meta": {
    "name": "demo-二次确认弹窗",
    "title": "ConfirmModal 二次确认弹窗",
    "isComponentDoc": true,
    "category": "Notice"
  }
};